import { Col, Row } from "react-bootstrap";
import React from "react";
import { useSelector } from "react-redux";
import ImpactBottom from "./ResultBottom/ImpactBottom";

export default function ImpactResult() {
  const economyResult = useSelector((state) => state.statehome.economyResult);
  const socialResult = useSelector((state) => state.statehome.socialResult);

  return (
    <Row>
      {economyResult.length ? (
        <Col sm={12} md={12}>
          <div
            className="card-university"
            style={{
              backgroundColor: "#fff",
              borderRadius: "15px",
            }}
          >
            <div className="card-header">
              <h5>เศรษฐกิจ</h5>
              <p>จำนวน {economyResult.length}</p>
            </div>
            <div className="card-university-body">
              <div className="list">
                {economyResult.map((data, index) => (
                  <div className="detail" key={index}>
                    <h6>
                      <b>โครงการวิจัย : </b> {data.concept_proposal_name_th}
                    </h6>
                    <h6>
                      <b>ปัจจัย :</b> {data.factor_name}
                    </h6>
                    <h6>
                      <b>ประเด็น :</b>{" "}
                      {data.issue_detail.map((rw, i) => (
                        <>
                          {i + 1}
                          {"."}
                          {rw.issue_detail}{" "}
                        </>
                      ))}
                    </h6>
                    <hr className="line-researcher" />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </Col>
      ) : (
        <ImpactBottom col={[12, 12, 12]} />
      )}

      {socialResult.length ? (
        <Col sm={12} md={12}>
          <div
            className="card-university"
            style={{
              backgroundColor: "#fff",
              borderRadius: "15px",
            }}
          >
            <div className="card-header">
              <h5>สังคม</h5>
              <p>จำนวน {socialResult.length}</p>
            </div>
            <div className="card-university-body">
              <div className="list">
                {socialResult.map((data, index) => (
                  <div className="detail" key={index}>
                    <h6>
                      <b>โครงการวิจัย : </b> {data.concept_proposal_name_th}
                    </h6>
                    <h6>
                      <b>ปัจจัย :</b> {data.factor_name}
                    </h6>
                    <h6>
                      <b>ประเด็น :</b>{" "}
                      {data.issue_detail.map((rw, i) => (
                        <>
                          {i + 1}
                          {"."}
                          {rw.issue_detail}{" "}
                        </>
                      ))}
                    </h6>
                    <hr className="line-researcher" />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </Col>
      ) : (
        <ImpactBottom col={[12, 12, 12]} />
      )}
    </Row>
  );
}
